import React, { Component } from 'react'
import { Tab, Row, Col } from 'react-bootstrap'

import RelatedDocumentsBodyAdapter from './RelatedDocumentsBodyAdapter'
import RelatedDocumentsBodyNavMenu from 'modules/RelatedDocuments/RelatedDocumentsBodyNavMenu'
import RelatedDocumentsBodyNavContent from 'modules/RelatedDocuments/RelatedDocumentsBodyNavContent'

import API from 'utils/api/api'
import APIURL from 'utils/api/urls'
import RegionTools from 'utils/regions/regionTools'

import Error from 'components/Error'
import Loading from 'components/Loading'

class RelatedDocumentsBody extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      error: false
    }
  }

  componentDidMount() {
    this.loadRelatedDocuments()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.selectedRegionId !== prevProps.selectedRegionId) {
      this.setState({ loading: true, error: false }, this.loadRelatedDocuments())
    }
  }

  loadRelatedDocuments() {
    let layer = this.props.layer
    let level = this.props.level
    let indicator = this.props.indicator
    let selectedRegionCode = RegionTools.getRegionCodeFromId({ regionsData: this.props.regionsData, id: this.props.selectedRegionId })
    let response

    if (layer === 1 || layer === 2) {
      response = API.getQuery(APIURL.getRelatedDocumentsLevel({ selectedRegionCode, level }))
    } else if (layer === 3) {
      response = API.getQuery(APIURL.getRelatedDocumentsIndicator({ selectedRegionCode, indicator }))
    }

    response
      .then(data => {
        return RelatedDocumentsBodyAdapter.getUsefulData(data)
      })
      .then(usefulData => {
        this.setState({ relatedDocumentsData: usefulData, loading: false, error: false })
        if (usefulData.length > 0) this.props.areAvailable(true)
        else this.props.areAvailable(false)
      })
      .catch(reason => {
        this.setState({ loading: false, error: true })
      })
  }

	setDefaultActiveTab = () => {
	  const relatedDocumentsData = this.state.relatedDocumentsData
	  const tabs = relatedDocumentsData
	    .map(item => item.year)
	    .sort()
	    .reverse()
	  return tabs[0]
	}

	renderIfAllOK() {
	  let renderingComponent = null
	  if (this.state.error) {
	    renderingComponent = <Error />
	  } else if (this.state.loading) {
	    renderingComponent = <Loading />
	  } else {
	    const defaultActiveTab = this.setDefaultActiveTab()
	    renderingComponent = (
	      <div className="ork-related-documents__body">
	        <Tab.Container id="tabs-with-dropdown" defaultActiveKey={defaultActiveTab}>
	          <Row className="clearfix">
	            <Col sm={12}>
	              <RelatedDocumentsBodyNavMenu relatedDocumentsData={this.state.relatedDocumentsData} />
	            </Col>
	            <Col sm={12}>
	              <RelatedDocumentsBodyNavContent relatedDocumentsData={this.state.relatedDocumentsData} />
	            </Col>
	          </Row>
	        </Tab.Container>
	      </div>
	    )
	  }

	  return renderingComponent
	}

	render() {
	  return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
	}
}

export default RelatedDocumentsBody



// WEBPACK FOOTER //
// ./src/modules/RelatedDocuments/RelatedDocumentsBody/RelatedDocumentsBody.jsx